import React, {useState} from "react";

export default function ShowMoreButton({text, trimLength}) {
    const [showMore, setShowMore] = useState(false)

    return (
        <p className='textwrap-up'>
            <div>
                {text.length < trimLength ? text :
                    showMore ? text : `${text.substring(0, trimLength)}`}
            </div>
            {text.length > trimLength && 
            <a className="fs14 metro-r text-orange cursor-pointer hover-text-blue" onClick={() => setShowMore(prev => !prev)}>
                {showMore ? "Show less" : "Show more"}
            </a>}
        </p>
    )
}
    